import React, { useMemo } from "react";
import { Row, Col } from "antd";
import { Form, Checkbox } from "formik-antd";
import { useTranslation } from "react-i18next";
import { IconToolTip } from "/app/src/components/icons/IconBuilder";

export default function NegativePick() {
  const { t } = useTranslation();

  const labelContent = useMemo(
    () => (
      <>
        {t("translation:negative_quantities")}
        <IconToolTip
          content={t("translation:negative_quantities_tip")}
          className="ml-1"
        />
      </>
    ),
    [t],
  );

  return (
    <Row justify="start" gutter={16}>
      <Col span={24}>
        <Form.Item
          name="negativeQuantity"
          label={labelContent}
          hasFeedback={false}
        >
          <Checkbox name="negativeQuantity" />
        </Form.Item>
      </Col>
    </Row>
  );
}
